import CouponDialog from '../components/CouponDialog/index.vue'
import { createFuncall } from 'vue-funcall'

let initialized = false

export const useCouponDialog = () => {
  onMounted(() => {
    if (initialized) return
    const showCouponDialog = !!localStorage.getItem('showCouponDialog')
    if (!showCouponDialog) return
    show()
    initialized = true
  })

  const show = () => {
    createFuncall(CouponDialog, {
      show: true
    })
    localStorage.removeItem('showCouponDialog')
  }

  const showCouponDialog = () => {
    // 解决部分场景登录完成后页面会强制刷新的情况
    localStorage.setItem('showCouponDialog', true)
    setTimeout(() => {
      show()
    }, 300)
  }

  return { showCouponDialog }
}
